import { render, staticRenderFns } from "./Bargain.vue?vue&type=template&id=50f1d723&scoped=true&"
import script from "./Bargain.vue?vue&type=script&lang=js&"
export * from "./Bargain.vue?vue&type=script&lang=js&"
import style0 from "./Bargain.vue?vue&type=style&index=0&id=50f1d723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f1d723",
  null
  
)

export default component.exports